export const CLIENT_LOGO_ATTACHMENT_TYPE = 'CLIENT_LOGO';

export const getClientLogoPath = (client) => {
  if (!client || !client.attachments) {
    return null;
  }

  const logoAttachment = client.attachments.find(
    (attachment) => attachment.attachmentType === CLIENT_LOGO_ATTACHMENT_TYPE
  );

  return logoAttachment ? logoAttachment.path : null;
};
